import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { ILoadingOrderPallet } from "model";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductListProps {
  doImportCode: string;
}
const PalletList = (props: IProductListProps) => {
  const { doImportCode } = props;
  const dispatch = useDispatch();
  const data = useAppSelector(
    (state) => state.LoadingOrderReducer.pallet.data!
  );
  const headerAction = useAppSelector(
    (state) => state.LoadingOrderReducer.action
  );
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.pallet.action
  );

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    _getAllLoadingOrderPallets();
  }, [
    searchText,
    headerAction.includes(
      LoadingOrderActions.importLoadingOrderDocument.successName
    ),
  ]);

  const _getAllLoadingOrderPallets = (pageNumber = 1) => {
    dispatch(
      LoadingOrderActions.getAllLoadingOrderPallets.request({
        pageNumber: pageNumber,
        pageSize: 100,
        doImportCode: doImportCode,
        searchText: searchText,
      })
    );
  };
  const _handlePageSizeChange = (pageSize: number) => {
    dispatch(
      LoadingOrderActions.getAllLoadingOrderPallets.request({
        pageNumber: 1,
        pageSize: pageSize,
        doImportCode: doImportCode,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "strStatus",
      headerName: I18nTranslator(translations.receive.status),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "userFullName",
      headerName: I18nTranslator(translations.receive.responsible),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "full",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productId),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.productName),
      size: "medium",
      align: "left",
      sortable: true,
    }),

    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.batchCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.quantity),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.receive.productCodeOld),
      size: "small",
      align: "left",
      sortable: true,
    }),
  ];
  return (
    <AppTable<ILoadingOrderPallet>
      loading={action.includes(
        LoadingOrderActions.getAllLoadingOrderProducts.requestName
      )}
      data={data}
      columns={COLUMNS}
      hideAddNew
      onSearch={setSearchText}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchLoadingOrderPallet
      )}
      onChangePage={(pageNumber: number) =>
        _getAllLoadingOrderPallets(pageNumber)
      }
      removeActionColumn
      hideHeader
      defaultHeaderTable={230}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default PalletList;
